/**
 * V70G8J — 관리자 세트 승자 입력 팝업: A/B 슬롯의 실제 참가자 표시명
 *
 * 기준은 같은 화면의 결과 정정 모달(CorrectionModal nameOf)과 동일:
 *   팀전 → 대진표 참가자 스냅샷의 teamName (참가신청 팀명 필드에서 생성된 값)
 *   개인전 → displayName / ownerDisplayName
 * 표시 전용이다. 저장은 기존처럼 슬롯('A'|'B')으로만 하므로 표시명이 같거나 비어 있어도 다른 팀이 저장되지 않는다.
 */
export type MatchSide = 'A' | 'B';

interface ParticipantLike {
  publicParticipantId?: string | null;
  mode?: string | null;
  teamName?: string | null;
  displayName?: string | null;
  ownerDisplayName?: string | null;
}

const clean = (v: unknown): string => {
  const s = typeof v === 'string' ? v.trim() : '';
  return s && s !== '-' ? s : '';
};

/** 참가자 표시명. 찾지 못하거나 이름이 없으면 null (호출부에서 대체 표시) */
export function participantDisplayName(
  participants: ReadonlyArray<ParticipantLike> | null | undefined,
  publicParticipantId: string | null | undefined,
): string | null {
  if (!publicParticipantId || !participants) return null;
  const p = participants.find((pp) => pp.publicParticipantId === publicParticipantId);
  if (!p) return null;
  if (p.mode === 'team') return clean(p.teamName) || null;
  return clean(p.displayName) || clean(p.ownerDisplayName) || null;
}

/** 팝업 표시용: 이름이 없으면 "팀 A"/"참가자 A" 같은 슬롯 기반 대체 표시 */
export function matchSideLabel(
  participants: ReadonlyArray<ParticipantLike> | null | undefined,
  publicParticipantId: string | null | undefined,
  side: MatchSide,
  isTeam: boolean,
): string {
  return participantDisplayName(participants, publicParticipantId) || `${isTeam ? '팀' : '참가자'} ${side}`;
}
